import { c as _c } from "react/compiler-runtime";
import { getHostedIdentifySessionRequirementsOptions } from '@onefootprint/fetch-hosted';
import type { IdentifyRequirementLogin } from '@onefootprint/request-types';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { isSessionExpired } from '@/idv2/features/identify/handle-session-expired';
import { PhoneKbaChallenge } from '@/idv2/features/identify/phone-kba-challenge';
import { useTenantLogo } from '@/idv2/features/identify/use-tenant-logo';
type KbaLoaderData = {
  loginRequirement: IdentifyRequirementLogin;
};
export const Route = createFileRoute('/identify/kba')({
  component: KbaPage,
  loader: async ({
    context
  }): Promise<KbaLoaderData> => {
    const headers = {
      'X-Fp-Authorization': context.onboardingSessionToken
    };
    const requirementsData = await context.queryClient.ensureQueryData(getHostedIdentifySessionRequirementsOptions({
      headers
    }));
    const loginRequirement = requirementsData?.requirements?.[0]?.kind === 'login' ? requirementsData.requirements[0] : undefined;
    if (!loginRequirement) {
      throw new Error('Reached /identify/kba without a login requirement');
    }
    return {
      loginRequirement
    };
  }
});
function KbaPage() {
  const $ = _c(9);
  const tenantLogo = useTenantLogo();
  const navigate = useNavigate();
  const {
    onboardingSessionToken
  } = Route.useRouteContext();
  const {
    loginRequirement
  } = Route.useLoaderData();
  let t0;
  if ($[0] !== loginRequirement.user?.scrubbedEmail || $[1] !== loginRequirement.user?.scrubbedPhone || $[2] !== navigate) {
    t0 = () => {
      navigate({
        to: "/identify/otp/$challengeKind",
        params: {
          challengeKind: "email"
        },
        search: {
          scrubbedEmail: loginRequirement.user?.scrubbedEmail,
          scrubbedPhone: loginRequirement.user?.scrubbedPhone
        }
      });
    };
    $[0] = loginRequirement.user?.scrubbedEmail;
    $[1] = loginRequirement.user?.scrubbedPhone;
    $[2] = navigate;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleSuccess = t0;
  let t1;
  if ($[4] !== handleSuccess || $[5] !== loginRequirement || $[6] !== onboardingSessionToken || $[7] !== tenantLogo) {
    t1 = <PhoneKbaChallenge headerIcon={tenantLogo} loginRequirement={loginRequirement} onboardingSessionToken={onboardingSessionToken} onSuccess={handleSuccess} onError={_temp} />;
    $[4] = handleSuccess;
    $[5] = loginRequirement;
    $[6] = onboardingSessionToken;
    $[7] = tenantLogo;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}
function _temp(error) {
  if (isSessionExpired(error)) {
    throw error;
  }
}